export enum CustomLayers {
    JACKPOTS = "Jackpots",
    RAYS = "Rays",
    FIREWORK_SPARK = "FireworkSpark",
    FIREWORKS = "Fireworks",
    LUCK = "LuckHasArrived",
    FIREWORK_EXPLOSION = "FireworkExplosion",
    BIGWIN_TEXT = "BigWinText",
    BigWinEmitter = "BigWinEmitter"
}

export enum JackpotTiers {
    GRAND = "grand",
    MINOR = "minor",
    MAJOR = "major",
    MINI = "mini"
}

export const TierNames: Map<string, JackpotTiers> = new Map<string, JackpotTiers>([
    ["mini", JackpotTiers.MINI],
    ["midi", JackpotTiers.MINOR],
    ["maxi", JackpotTiers.MAJOR],
    ["grand", JackpotTiers.GRAND]
] as any);
